import './QuickAccess.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FeatureBoundary } from '@ui/features';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { Menu } from 'antd';
import { QuickAccessApps } from './QuickAccessApps';
import { QuickAccessComplianceCategories } from './QuickAccessComplianceCategories';
import { QuickAccessTags } from './QuickAccessTags';
import { QuickAccessViews } from './QuickAccessViews';
import React from 'react';
import { SearchTypeLabel } from './SearchTypeLabel';
import { SonarCard } from '@ui/general';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { SonarText } from '@ui/text';
import { UpdateQueryParams } from '@hooks';

import {
	DataDictionarySearchQueryParams,
	SearchGroup,
	SearchOptionGroup,
	sonarObjectTypeOrder
} from './DataDictionarySearch';

export interface QuickAccessProps {
	updateQuery: UpdateQueryParams<DataDictionarySearchQueryParams>;
}

const entityItems: Array<SearchGroup> = [ {
	children:
		Object.values(sonarObjectTypeOrder).map((type) =>
			({
				group: SearchOptionGroup.ObjectType,
				key: type,
				label: <SearchTypeLabel sonarObjectType={ type } />,
				value: type
			})),
	key: 'title',
	label: COPY_SPECIFIC.ENTITIES,
	type: 'group'
} ];

export const QuickAccess: React.FC<QuickAccessProps> = ({ updateQuery }) =>
	<SonarCard
		className='quick-access'
		title={
			<SonarText
				size={ 20 }
				weight='semibold'>{ COPY_SPECIFIC.QUICK_ACCESS }
			</SonarText>
		}>
		<div className='quick-access-menus'>
			<Menu
				className='quick-access-menu'
				items={ entityItems }
				mode='inline'
				onClick={ (info) => {
					updateQuery({ sonarObjectType: info.key as SonarObjectType });
				} } />
			<QuickAccessViews onSelect={ updateQuery } />
			<QuickAccessTags onSelect={ (tagId) => updateQuery({ tagId }) } />
			<FeatureBoundary feature={ FeatureFlag.DataSecurityDashboard }>
				<QuickAccessApps
					onSelect={ (applicationId, displayName) =>
						updateQuery({
							applicationId,
							displayName
						}) } />
			</FeatureBoundary>
			<QuickAccessComplianceCategories onSelect={ updateQuery } />
		</div>
	</SonarCard>;

